import {useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "axios";
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";

const RefreshToken = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    let redirect = searchParams.get("redirect")
    useEffect(() => {
        axios.post(constants.serverURL + "tokenRefresh", [],      {
            withCredentials: true,
        }).then(response => {
            window.location.href = constants.websiteURL + "#/" + redirect
        }).catch((error) => {
            window.location.href = constants.websiteURL + "#/"
        })
    })
    return (
        <div>
            <MenuAppBar title="" signedIn={false}></MenuAppBar>
            <h1>
                Refreshing...
            </h1>
        </div>
    );
}
export default RefreshToken